<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Report</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-3" v-if="role == 'admin'">
        <div class="form-group">
          <label>Merchant</label>
          <select class="form-control" v-model="merchant">
            <option value>All</option>
            <option value="Burger King">Burger King</option>
            <option value="KFC">KFC</option>
            <option value="McDonald's">McDonald's</option>
            <option value="Pizza Hut">Pizza Hut</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Code</label>
          <input
            type="text"
            placeholder=""
            class="form-control"
            maxlength="20"
            v-model="code"
          />
        </div>
      </div>
      <div class="col-md-2 fit-content">
        <div class="form-group">
          <label>Start Date</label>
          <input type="date" class="form-control" v-model="startDate" />
        </div>
      </div>
      <div class="col-md-2 fit-content">
        <div class="form-group">
          <label>Expiry Date</label>
          <input type="date" class="form-control" v-model="expiryDate" />
        </div>
      </div>
      <div class="col-md-3 fit-content">
        <div class="form-group">
          <label>Discount Type</label>
          <select class="form-control" v-model="discountType">
            <option value>All</option>
            <option value="Percentage Discount">Percentage Discount</option>
            <option value="Amount Discount">Amount Discount</option>
          </select>
        </div>
      </div>
      <template v-if="role != 'admin'">
        <div class="col-md-2">
          <div class="form-group">
            <label>Status</label>
            <select class="form-control" v-model="status">
              <option value>All</option>
              <option value="Active">Active</option>
              <option value="Expired">Expired</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <button class="btn btn-primary filter-btn" @click="search">
            Generate Report
          </button>
        </div>
      </template>
    </div>
    <div class="row" v-if="role == 'admin'">
      <div class="col-md-2">
        <div class="form-group">
          <label>Status</label>
          <select class="form-control" v-model="status">
            <option value>All</option>
            <option value="Draft">Draft</option>
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary filter-btn" @click="search">
          Generate Report
        </button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th v-if="role == 'admin'">Merchant</th>
                <th>Code</th>
                <th>Start Date</th>
                <th>Expiry Date</th>
                <th>Discount Type</th>
                <th>Discount Amount</th>
                <th class="text-center">
                  Number of Coupon(s)<br />
                  Generated
                </th>
                <th class="text-center">Number of Coupon(s)<br />Redeemed</th>
                <th class="text-center">
                  Number of Coupon(s)<br />
                  Not Redeemed
                </th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ecoupon, i) in ecoupons" :key="i">
                <td v-if="role == 'admin'">{{ ecoupon.merchant }}</td>
                <td>{{ ecoupon.code }}</td>
                <td>{{ ecoupon.startDate }}</td>
                <td>{{ ecoupon.expiryDate }}</td>
                <td>{{ ecoupon.discountType }}</td>
                <td>{{ ecoupon.discountAmount }}</td>
                <td>{{ ecoupon.totalGenerated }}</td>
                <td>
                  <a
                    v-if="ecoupon.totalRedeemed > 0"
                    href="javascript:void(0)"
                    @click="showRedemptionDetail(ecoupon.code)"
                  >
                    {{ ecoupon.totalRedeemed }}
                  </a>
                  <span v-else>{{ ecoupon.totalRedeemed }}</span>
                </td>
                <td>{{ ecoupon.totalNotRedeemed }}</td>
                <td>{{ ecoupon.status }}</td>
              </tr>
              <tr v-if="ecoupons && !ecoupons.length">
                <td colspan="10" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="ecoupons && ecoupons.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          ecoupons.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Redeemed Customer Modal -->
    <div class="modal custom-modal fade" id="redemptionDetail" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">{{ redemptionDetail.code }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
              <table class="table table-bordered custom-table mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Date of Birth</th>
                    <th>Gender</th>
                    <th>Redemption Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(customer, i) in redemptionDetail.redeemedCustomers"
                    :key="i"
                  >
                    <td>{{ customer.name }}</td>
                    <td>{{ customer.email }}</td>
                    <td>{{ customer.dob }}</td>
                    <td>{{ customer.gender }}</td>
                    <td>{{ customer.redemptionDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Redeemed Customer Modal -->
  </div>
</template>

<script>
import config from "../../config.js";
import $ from "jquery";
export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      ecoupons: [],
      redemptionDetail: { code: "", redeemedCustomers: [] },
      //pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
      //filter
      merchant: "",
      code: "",
      startDate: "",
      expiryDate: "",
      discountType: "",
      distributionChannel: "",
      status: "",
    };
  },
  computed: {
    role() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data.role;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getUserList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    search() {},
    showRedemptionDetail(code) {
      this.redemptionDetail.code = code;
      this.redemptionDetail.redeemedCustomers = this.ecoupons.find(
        (c) => c.code == code
      ).redeemedCustomers;
      $("#redemptionDetail").modal("show");
    },
    getEcouponList() {
      this.ecoupons = [
        {
          merchant: "Burger King",
          code: "BK-001",
          startDate: "1 January 2025",
          expiryDate: "31 December 2025",
          discountType: "Percentage Discount",
          discountAmount: "30%",
          totalGenerated: 10,
          totalRedeemed: 5,
          totalNotRedeemed: 5,
          status: "Active",
          redeemedCustomers: [
            {
              name: "Andy",
              email: "andy@gmail.com",
              dob: "20 January 1988",
              gender: "Male",
              redemptionDate: "5/12/2024 10:59:25",
            },
            {
              name: "Alan",
              email: "alan@gmail.com",
              dob: "19 March 1985",
              gender: "Male",
              redemptionDate: "4/12/2024 11:14:22",
            },
            {
              name: "Susy",
              email: "susy@outlook.com",
              dob: "19 April 1988",
              gender: "Female",
              redemptionDate: "3/12/2024 10:04:22",
            },
            {
              name: "Susan",
              email: "susan@gmail.com",
              dob: "2 August 1988",
              gender: "Female",
              redemptionDate: "2/12/2024 10:04:22",
            },
            {
              name: "Garry",
              email: "garry@yahoo.com",
              dob: "4 October 1988",
              gender: "Male",
              redemptionDate: "1/12/2024 9:04:22",
            },
          ],
        },
        {
          merchant: "KFC",
          code: "KFC-XA9D1",
          startDate: "1 January 2025",
          expiryDate: "31 January 2025",
          discountType: "Amount Discount",
          discountAmount: "$20",
          totalGenerated: 1,
          totalRedeemed: 1,
          totalNotRedeemed: 0,
          status: "Active",
          redeemedCustomers: [
            {
              name: "Garry",
              email: "garry@yahoo.com",
              dob: "4 October 1988",
              gender: "Male",
              redemptionDate: "12/12/2024 9:05:21",
            },
          ],
        },
        {
          merchant: "McDonald's",
          code: "MCD-1242",
          startDate: "1 April 2024",
          expiryDate: "2 April 2024",
          discountType: "Amount Discount",
          discountAmount: "$25",
          totalGenerated: 2,
          totalRedeemed: 0,
          totalNotRedeemed: 2,
          status: "Expired",
          redeemedCustomers: [],
        },
        {
          merchant: "Pizza Hut",
          code: "PHT-1242",
          startDate: "1 May 2025",
          expiryDate: "2 May 2025",
          discountType: "Percentage Discount",
          discountAmount: "25%",
          distributionChannel: "Email",
          totalGenerated: 4,
          totalRedeemed: 1,
          totalNotRedeemed: 3,
          status: "Active",
          redeemedCustomers: [
            {
              name: "Michael",
              email: "michael@yahoo.com",
              dob: "1 May 1978",
              gender: "Male",
              redemptionDate: "11/12/2025 19:04:22",
            },
          ],
        },
      ];
      this.totalRecords = this.ecoupons.length;
      this.paging.TotalPage = 1;
      if (this.paging.CurrentPage > this.paging.TotalPage) {
        this.paging.CurrentPage = 1;
      }
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEcouponList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEcouponList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEcouponList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEcouponList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEcouponList();
    },
  },
  created() {
    this.getEcouponList();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Share/Report.vue